import { render, staticRenderFns } from "./MemberRecommendations.vue?vue&type=template&id=4d1d7790"
import script from "./MemberRecommendations.vue?vue&type=script&lang=js"
export * from "./MemberRecommendations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports